export default __webpack_public_path__ + "static/media/logo-on.fa173921.png";